import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Divider, Input, Popover, List, Tooltip, Spin } from 'antd'
import { setCurrentBranch, setBranches } from 'Actions/branches'
import Feather from '@sysunite/react-feather'
import BranchListItem from './BranchListItem'
import { DeleteTwoTone, PlusOutlined, BranchesOutlined } from '@ant-design/icons'
import './index.scss'

{ Search } = Input

BranchSwitchButton = ({ displayConfigData, currentProject, currentBranch, branches = [], setBranches, setCurrentBranch }) ->

  [filterText, setFilterText] = useState('')
  [loading, setLoading] = useState(true)
  [createBranchText, setCreateBranchText] = useState()

  useEffect( ->
    return unless currentProject?
    ( ->
      setLoading(true)
      setBranches(_.filter(await Weaver.Branch.list(), (branch) ->
        unless displayConfigData
          branch.id() isnt '$config'
        else
          true
      ))
      setLoading(false)
    )()
    undefined
  , [currentProject])

  useEffect(->
    if currentBranch? and currentBranch in branches.map((b) -> b.id())
      Weaver.getInstance().useBranch(branches.find((branch) -> branch.id() is currentBranch))
    else if branches.length > 0
      branch = branches.find((branch) -> branch.id() is 'main' )
      setCurrentBranch(branch.id())
      Weaver.getInstance().useBranch(branch)
    undefined
  , [branches])

  branchlist = (
    <div data-testid="branch-switcher-list" style={{ overflow: 'auto', maxHeight: '44vh' }}>
      <div className="search-container">
        <Search
          placeholder="Search branches"
          value={filterText}
          onChange={(e) -> setFilterText(e.target.value)}
        />
      </div>
      <List
        bordered={false}
        dataSource={branches.filter((branch) -> branch.id().toLowerCase().includes(filterText.toLowerCase()))}
        renderItem={(branch) ->
          <BranchListItem branch={branch}/>
        }
      />
    </div>
  )

  <Popover
    overlayClassName="branch-management-popover"
    placement="top"
    content={branchlist}
    trigger="click"
  >
    <Button
      type="text"
      shape="round"
      data-testid="branch-switcher"
      loading={loading}
      icon={<BranchesOutlined />}
    >
      { branches.find((branch) -> branch.id() is currentBranch)?.name() }
    </Button>
  </Popover>

mapStateToProps = ({ branches, projects }) ->
  {
    currentProject: projects.currentProject
    currentBranch: branches.currentBranch
    branches: branches.branches
    displayConfigData: projects.displayConfigEnabled
  }

export default connect(mapStateToProps, {
  setBranches, setCurrentBranch
})(BranchSwitchButton)
